// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jc-text[data-v-7b3e30c6]{flex:1 1;min-width:0}.jc-text__name[data-v-7b3e30c6]{font-size:1.0625rem;font-weight:700}.jc-text__company-name[data-v-7b3e30c6],.jc-text__name[data-v-7b3e30c6]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.jc-text__company-name[data-v-7b3e30c6]{--text-opacity:1;color:#8e8e8e;color:rgba(142,142,142,var(--text-opacity))}.jc-text__districts[data-v-7b3e30c6]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
